import { render, staticRenderFns } from "./TarjetaCompleto.vue?vue&type=template&id=8386b708"
import script from "./TarjetaCompleto.vue?vue&type=script&lang=js"
export * from "./TarjetaCompleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports